function notFound404ErrorHandler(err) {
    if (err.code === 404)
        return []
    throw err;
}

export default notFound404ErrorHandler;